/** Toggle/Switcher Theme - Dark or Light mode **/
const switchTextByTheme = document.querySelectorAll(".header-switch__container");
switchTextByTheme.forEach(item => {
    item.addEventListener('click', toggleTheme)
})
function setTheme(themeName) {
    localStorage.setItem('theme', themeName);
    document.body.className = themeName;
}
function toggleTheme() {
    if (localStorage.getItem('theme') === 'dark'){
        setTheme('light');
    } else {
        setTheme('dark');
    }
}
(function() {
    if (localStorage.getItem('theme') === 'dark') {
        setTheme('dark');
    } else {
        setTheme('light');
    }
})();

/** END Toggle/Switcher Theme - Dark or Light mode **/

/**
 * Удаление лоадера из dom дерева после загрузки страницы
 * Скрипт отрабатывает в любом случае, даже если есть ошибки в JS
 */
window.onload = function() {
    $('body').removeClass('loaded');
    let loader = document.querySelector('.loader');
    loader.parentNode.removeChild(loader);
};

$(document).ready(function() {
    /** Глобальные переменные */
    var WIN = $(window),
        DOC = $(document),
        HTML = $('html'),
        BODY = $('body');

    /** Определяем браузеры Internet Explorer 11 и Edge */
    let ua = window.navigator.userAgent,
        edge_ua = ua.indexOf('Edge/'),
        ie_ua = ua.indexOf('Trident/7.0'),
        edge = 'edge',
        ie = 'ie';
    if (edge_ua > 0) {
        HTML.addClass(edge);
    }
    if (ie_ua + 1) {
        HTML.addClass(ie);
    }


    /** Добавляем стили и скрипты для браузера Internet Explorer 11 */
    if (HTML.hasClass(ie)) {
        HTML.append('<script src="../../js/' + ie + '.js"></script>');
        HTML.append('<link href="../../css/' + ie + '.css" rel="stylesheet">');
    }

    /** Профиль игрока с привязанными соц сетями**/
    function socialMenu() {
        let opener = $('[data-profile-social]');
        let wrapper = $('[data-social-wrapper]');
        opener.on('click', function (e) {
            wrapper.toggleClass('opened');
        })
    }
    socialMenu();

    /** Мобильное меню **/

    function mobileMenu() {
        let opener = $('[data-mobile-menu]');
        let wrapper = $('[data-mobile-wrapper]');
        opener.on('click', function (e) {
            $(this).toggleClass('active');
            wrapper.toggleClass('opened');
        })

}
        mobileMenu();
        // DOC.on('click', '.mobile-wrapper', function() {
        // 	console.log('click');
        // 	$('[data-mobile-wrapper]').removeClass('opened');
        // });

        // WIN.on('resize', function() {
        //     $('.mobile-wrapper.opened').each(function() {
        //         $('.mobile-wrapper.opened').removeClass('opened');
        //     });
        // });


        window.addEventListener("orientationchange", function () {
            $('.mobile-wrapper.opened').each(function () {
                $('.mobile-wrapper.opened').removeClass('opened');
            });
        }, false);

        function mobileMenuUser() {
            let opener = $('[data-mobile-menu-user]');
            let wrapper = $('[data-mobile-wrapper-user]');
            let closer = $('[data-mobile-menu-closer]');

            opener.on('click', function (e) {
                e.preventDefault();
                wrapper.toggleClass('opened');
            })
            closer.on('click', function (e) {
                e.preventDefault();
                wrapper.removeClass('opened');
            })
        }

        mobileMenuUser();


        // if(WIN.width() >= 1024){
        //     $('.helper').on('mouseenter', '.header .user-avatar, [data-mobile-wrapper-user] *', function() {
        //         let wrapper = $('[data-mobile-wrapper-user]');
        //         $('.header .user-avatar').addClass('opened');
        //         wrapper.addClass('opened');
        //     });
        //     $('.helper').on('mouseleave', '.header .user-avatar, [data-mobile-wrapper-user]', function() {
        //         let wrapper = $('[data-mobile-wrapper-user]');
        //         $('.header .user-avatar').removeClass('opened');
        //         wrapper.removeClass('opened');
        //     });
        // }


        /** End мобильного меню **/


        /** Рейтинг игры на странице Demo game **/
        var rating = $('[data-rating]');
        var isLogged = rating.data('logged') ? true : false;


        rating.rating({
            width: 20,
            fx: 'half',
            image: '/img/elements/stars.svg',
            loader: '/img/elements/ajax-loader.gif',
            readOnly: isLogged
        });
        if (isLogged) {
            $('.vote-hover').css({
                'cursor': 'default'
            });
        }
        /** End Рейтинг игры на странице Demo game **/


        /**
         * Cлайдер на странице c играми
         * + хак для loop, чтобы отрабатывал watchOverflow: true (скрывается пагинация\навигация, если только 1 слайд)
         * */
        let slider_main_count = $('[data-slider-main] .swiper-slide').length;
        var mainSlider = new Swiper('[data-slider-main]', {
            speed: 1000,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            watchOverflow: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            effect: 'fade',
            initialSlide: 0,
            centeredSlides: true,
            loop: slider_main_count > 1,
            lazy: true,
            navigation: {
                nextEl: '[data-slider-main] .swiper-button-next',
                prevEl: '[data-slider-main] .swiper-button-prev',
                clickable: true
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });


        /** Cлайдер game menu */
        $('[data-slider-menu]').each(function () {
            // используемые классы
            let name = $(this);

            let menuSlider = new Swiper(name.find('.swiper-container'), {
                slidesPerView: 'auto',
                freeMode: true,
                slideClass: 'games__menu-item',
                scrollbar: {
                    el: name.find('.swiper-scrollbar'),
                    hide: false
                }
            });
        });


        /** Cлайдер game-type menu */
        $('[data-slider-type-menu]').each(function () {
            // используемые классы
            let name = $(this);

            let menuSlider = new Swiper(name.find('.swiper-container'), {
                slidesPerView: 'auto',
                freeMode: true,
                slideClass: 'games-types__item',
                scrollbar: {
                    el: name.find('.swiper-scrollbar'),
                    hide: false
                }
            });
        });

        /**
         *  Слайдер игр на главной
         *  Для инициализации слайдера нужно только в html добавить аттрибут data-slider-main-games
         *  Все нужные классы добавляются во время инициализации слайдера
         **/
        $('[data-slider-main-games]').each(function () {
            let container = $(this);

            container.find('.games').addClass('swiper-container');
            container.find('.games__list').addClass('swiper-wrapper').removeClass('games__list');

            let gameSlider = new Swiper(container.find('.swiper-container'), {
                watchOverflow: true,
                loop: false,
                centeredSlides: false,
                slideClass: 'games__item',
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 10,
                // allowTouchMove: false,
                simulateTouch: true,
                pagination: {
                    el: container.find(' .swiper-pagination'),
                    clickable: true
                },
                breakpoints: {
                    680: {
                        slidesPerView: 2
                    },
                    1024: {
                        slidesPerView: 3
                    }
                }
            });
        });
        // /** Cлайдер game menu */
        // $('[data-slider-menu]').each(function() {
        //     // используемые классы
        //     let name = $(this);
        //
        //     let menuSlider = new Swiper(name.find('.swiper-container'), {
        //         slidesPerView: 'auto',
        //         freeMode: true,
        //         slideClass: 'games__menu-item',
        //         scrollbar: {
        //             el: name.find('.swiper-scrollbar'),
        //             hide: false
        //         }
        //     });
        // });
        // /** Cлайдер game menu */

        /** Слайдер победителей на главной **/
        var winnersSlider = new Swiper('[data-slider-winners]', {
            speed: 1000,
            slidesPerView: 5,
            slidesPerGroup: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '.winners .icon-button-next',
                prevEl: '.winners .icon-button-prev'
            },
            breakpoints: {
                280: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3,
                    // slidesPerGroup: 3,
                    // spaceBetween: 20
                },
                1220: {
                    slidesPerView: 3,
                    // slidesPerGroup: 4,
                    spaceBetween: 20
                },
                1440: {
                    slidesPerView: 3
                },
                1600: {
                    slidesPerView: 4
                },
                1700: {
                    slidesPerView: 5
                },


            }
        });
        /**  End Слайдер победителей на главной **/

        /** Слайдер на главной **/
        var itemsSlider = new Swiper('[data-items-slider] .swiper-container', {
            speed: 1000,
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '[data-items-slider] .icon-button-next',
                prevEl: '[data-items-slider] .icon-button-prev'
            },
            watchOverflow: true,
            breakpoints: {
                280: {
                    slidesPerView: 1,
                    spaceBetween: 30
                },
                320: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                440: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                640: {
                    slidesPerView: 4,
                    spaceBetween: 40
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                980: {
                    slidesPerView: 5
                },
                1440: {
                    slidesPerView: 5,
                    spaceBetween: 80
                }
            }
        });
        /** End слайдер на главной **/

        /** Слайдер Платежных методов на главной **/
        var paymentsSlider = new Swiper('[data-payment-slider] .swiper-container', {
            speed: 1000,
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '[data-payment-slider] .icon-button-next',
                prevEl: '[data-payment-slider] .icon-button-prev'
            },
            watchOverflow: true,
            breakpoints: {
                280: {
                    slidesPerView: 1
                },
                320: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                440: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                640: {
                    slidesPerView: 4,
                    spaceBetween: 40
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                980: {
                    slidesPerView: 5
                },
                1440: {
                    slidesPerView: 5,
                    spaceBetween: 80
                }
            }
        });
        /** End слайдер Платежных методов на главной **/


        /** Слайдер турнирных игр на странице турниры и турнир **/

        $('[data-recent-games-slider]').each(function () {
            // используемые классы
            let name = $(this);
            let recentSlider = new Swiper(name.find('.swiper-container'), {
                speed: 1000,
                slideClass: 'games-recent__item',
                slidesPerView: 5,
                slidesPerGroup: 1,
                spaceBetween: 25,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },

                breakpoints: {
                    480: {
                        slidesPerView: 1,
                        slidesPerGroup: 1

                    },
                    980: {
                        slidesPerView: 2,
                        slidesPerGroup: 2

                    },
                    1200: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    },
                    1440: {
                        slidesPerView: 4,
                        slidesPerGroup: 4
                    }
                }
            });
        });

        /** Слайдер выбора бонуса на депозит в модалке **/
        function chooseBonus() {
            $('[data-choose-bonus-slider]').each(function () {
                let name = $(this);
                if (name.length > 0 && name.is(':visible') && name.find('.swiper-slide-active').length < 1) {
                    // используемые классы
                    let chooseSlider = new Swiper(name.find('.swiper-container'), {
                        slideClass: 'bonuses__item',
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        spaceBetween: 25,
                        pagination: {
                            el: name.find('.swiper-pagination'),
                            clickable: true
                        },
                        navigation: {
                            nextEl: name.find(' .slider-arrow--next'),
                            prevEl: name.find(' .slider-arrow--prev'),
                        }
                    });
                }

            });
        }

        chooseBonus();


        /*** Search Bar/Поиск с кнопкой удаления содержимого поля ввода
         *
         */
        function searchBar() {
            let activator = $('[data-search-bar]');
            let input = $('[data-search-input]');
            let cleaner = $('[data-search-cleaner]');

            input.keyup(function () {
                if ($.trim(this.value).length > 0) {
                    activator.addClass('active')
                }
                else {
                    activator.removeClass('active')
                }
            });
            cleaner.on('click', function () {
                input.val('');
                activator.removeClass('active');
            })
        }

        searchBar();


        /**
         * Стилизация скроллабара в блоках
         */
        $('[data-scrollbar]').scrollbar({
            "showArrows": true,
            "scrolly": 'advanced',
            "ignoreOverlay": false
        });


        /**
         * Аккордеон на странице игры (отображение\скрытие дополнительной информации в правой панели)
         * **/
        DOC.on('click', '[data-accordion]', function () {
            let item = $(this).parents('[data-accordion-item]');
            item.toggleClass('accordion__item--open');
        });


        /** Отображение полного описания игры **/
        DOC.on('click', '[data-game-more]', function () {
            $('.game-info__description').toggleClass("open");
            $(this).parents('.game-info__description-buttons').hide();
        });
        /** Отображение полного описания игры **/


        /** jackpots counter for numbers **/
        $('[data-jackpots-counter]').countUp();

        /** end jackpots counter for numbers **/

        /** обрезка текстовых привью (количество символов береться из дата атрибута) **/
        function dataCutText() {
            var shortText = $('[data-cut-text]');
            shortText.each(function () {
                var size = $(this).data('cutText'),
                    elementText = $.trim($(this).text());
                if (elementText.length > size) {
                    $(this).text(elementText.slice(0, size) + ' ...');
                }
            });
        }

        dataCutText();


        /**
         * Этот код подменяет ссылку на ссылках "Назад".
         * Смысл этих сложностей в том, чтобы поставить на ссылку "Назад" изначально повесить ссылку
         * на главную, которая сработает если посетитель пришел по прямой ссылке, а потом уже вешать
         * действительно предыдущую страницу, когда посетитель походил по страницам.
         * */
        if (window.sessionStorage.currPage) {
            if (!window.sessionStorage.prevPage || window.sessionStorage.currPage !== window.location.toString()) {
                window.sessionStorage.prevPage = window.sessionStorage.currPage;
            }
        }
        else{
            window.sessionStorage.prevPage = '/gameList';
        }
        if (window.sessionStorage.prevPage) {
            $('[data-go-back]').attr('href', window.sessionStorage.prevPage);
        }
        window.sessionStorage.currPage = window.location.toString();


        /** Mobile tables **/
        (function () {
            var headertext = [];
            var headers = document.querySelectorAll("thead");
            var tablebody = document.querySelectorAll("tbody");

            for (var i = 0; i < headers.length; i++) {
                headertext[i] = [];
                for (var j = 0, headrow; headrow = headers[i].rows[0].cells[j]; j++) {
                    var current = headrow;
                    headertext[i].push(current.textContent.replace(/\r?\n|\r/, ""));
                }
            }
            if (headers.length > 0) {
                for (var h = 0, tbody; tbody = tablebody[h]; h++) {
                    for (var i = 0, row; row = tbody.rows[i]; i++) {
                        for (var j = 0, col; col = row.cells[j]; j++) {
                            col.setAttribute("data-label", headertext[h][j]);
                        }
                    }
                }
            }
        }());

        /** End Mobile tables **/


        /**
         * Функция переключения типов отображения контента
         *
         *   data-view-title - имя переключалки на каждой конкретной странице. Должно быть уникально, т.к. создаётся
         *      переменная в localStorage, в ней хранится значение вида, который выбрал пользователь
         *
         *   data-view - имя вида отображения. Указывается для каждой кнопки. Сохраняется в localStorage в переменной
         *      с именем из data-view-title
         *
         *   data-view-default - тип, который выбирается по умолчанию при загрузке страницы, если в localStorage не сохранён
         *      выбранный пользователем тип отображения. Указывается только для одной кнопки из списка
         *
         *   data-view-content - в значение этого аттрибута проставляется тип, который выбран пользователем при клике на иконку
         *      или тип по умолчанию, если пользователь не делал выбора. Используется в стилях как родитель, отталкиваясь от
         *      которого мы делаем стилизацию контента в зависимости от выбранного блока
         *
         *      Пример:
         *          [data-view-content=table]
         *              .games__item
         *                  width 100%
         *
         * */
        function viewSwitcher() {

            let current_tab = localStorage.getItem($('[data-view-title]').data('view-title')),
                default_tab = $('[data-view-default]').data('view');

            // при загрузке страницы проверяеместь ли в localStorage сохранённое значение
            if (current_tab !== null) {
                // если есть - выбираем соответсвующую кнопку активной и записываем в data-view-content для стилизации
                $('[data-view-content]').attr('data-view-content', current_tab);
                $('[data-view=' + current_tab + ']').addClass('active');
            } else {
                // если нет - выбираем активным иконку, которая указана как дефолтная
                $('[data-view-content]').attr('data-view-content', default_tab);
                $('[data-view=' + default_tab + ']').addClass('active');
            }

            // при клике на любую из иконок делаем её активной и записываем в localStorage тип отображения
            DOC.on('click', '[data-view]', function () {
                let tab_type = $(this).data('view'),
                    tab_current = $('[data-view-title]').data('view-title'),
                    tab_content = $('[data-view-content]');

                if (!$(this).hasClass('active')) {
                    $('[data-view]').removeClass('active');
                }

                $(this).addClass('active');
                tab_content.attr('data-view-content', tab_type);

                localStorage.setItem(tab_current, tab_type);
            })

            // TODO изящнее и универсальнее
            WIN.on('resize', function () {
                if (WIN.width() <= 768) {
                    $('[data-view=grid]').trigger('click');
                }
            });
        }

        viewSwitcher();


        /** profile-menu toggler for open/close **/
        DOC.on('click', '[data-profile-menu]:not(.opened) i', function (event) {
            event.preventDefault();
            $('[data-profile-menu]').addClass('opened');
            $('[data-profile-menu-closer] i').removeClass('icon-menu-open').addClass('icon-menu-close');
        });
        DOC.on('click', '[data-profile-menu].opened [data-profile-menu-closer]', function () {
            $('[data-profile-menu]').removeClass('opened');
            $('[data-profile-menu-closer] i').removeClass('icon-menu-close').addClass('icon-menu-open');
        });

        /** end profile-menu toggler for open/close **/


        /** ADD cookies List to Grid view for tables **/
        function setTableView() {
            if ($.cookie('TableView') == null) {
                $.cookie('TableView', 'grid-view', {
                    path: '/'
                });
            }
            if ($.cookie('TableView') == 'grid-view') {
                $('[data-view-grid]').click();
            }
            if ($.cookie('TableView') == 'table-view') {
                $('[data-view-table]').click();
            }
        }

        setTableView();
        /** END ADD cookies List to Grid view for tables **/


        /** Реализация адаптивности iframe в статьях **/
        $('.article__content iframe').each(function () {
            $(this).wrap('<div class="videowrapper">');
        });
        /** end **/


        /** Инициализация типовых модалок **/
        $('[data-modal]').magnificPopup({
            type: 'ajax',
            removalDelay: 300,
            mainClass: 'mfp-zoom-in',
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
                },
                ajaxContentAdded: function () {
                    this.content;
                },
                open: function () {
                    $('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
                },
                close: function () {
                    $('.header').css('width', '100%')
                },
                beforeOpen: function () {
                    $('body').addClass('blur');
                },
                beforeClose: function () {
                    $('body').removeClass('blur');
                }
            }
        });
        /** End Инициализация модалок **/


    /** Инициализация модального окна для выбора языков **/
        $('[data-modal-lang]').magnificPopup({
            type: 'ajax',
            removalDelay: 300,
            showCloseBtn: false,
            mainClass: 'mfp-zoom-in',
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
                },
                ajaxContentAdded: function () {
                    this.content;
                },
                open: function () {
                    $('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
                },
                close: function () {
                    $('.header').css('width', '100%')
                },
                beforeOpen: function () {
                    $('body').addClass('blur');
                },
                beforeClose: function () {
                    $('body').removeClass('blur');
                }
            }
        });
        /** End **/

        /** Инициализация модального окна, которое невозможно закрыть */
        $('[data-modal--immortal]').magnificPopup({
            type: 'ajax',
            removalDelay: 300,
            mainClass: 'mfp-zoom-in',
            closeOnBgClick: false,
            showCloseBtn: false,
            enableEscapeKey: false,
            callbacks: {
                parseAjax: function (mfpResponse) {
                    mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
                },
                ajaxContentAdded: function () {
                    this.content;
                },
                open: function () {
                    $('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
                },
                close: function () {
                    $('.header').css('width', '100%')
                },
                beforeOpen: function () {
                    $('body').addClass('blur');
                },
                beforeClose: function () {
                    $('body').removeClass('blur');
                }
            }
        });
        /** End **/

    /**
     * Поля ввода верификационного кода в модалке 2fac
     **/
        function enterCode(){
            let $formCode= $('[data-modal-code]');
            let $inputCode = $formCode.find('input[type="number"]');
            $inputCode.keydown(function(e){
                $(this).val('');
            });

            $inputCode.keyup(function(e){
                var val = $(this).val();

                // Ввод только цифр
                if(val == val.replace(/[0-9]/, '')) {
                    $(this).val('');
                    return false;
                }

                // Передача фокуса следующему input
                $inputCode.eq($inputCode.index(this) + 1).focus();

                // Заполнение input hidden
                var fullval = '';
                $inputCode.each(function(){
                    fullval = fullval + (parseInt($(this).val()) || '0');
                });
                $formCode.find('input[type="hidden"]').val(fullval);
            });
        }
        enterCode();
        /**
         * END Поля ввода верификационного кода в модалке 2fac
         **/


        /**
         * Появление и скрытие поля с ответом на секретный вопрос
         * Появление\скрытие инпута в инициализации selectric'a
         **/
        let secret_question = $('[data-secret-question]'),
            secret_answer = $('.secret_answer');
        // secret_question.find('option[value=0]').val('');
        if (secret_question.val()) {
            secret_answer.hide();
        }


        /** End **/

        /**
         * Инициализация select menu
         * Используется в формах, которые подгружаются на ajax
         * Для этого вынесен в функцию для использования внутри ajaxSuccess
         **/
        function selectInit() {
            $('[data-select-menu]').each(function () {
                if (!$(this).parent().hasClass('selectric-hide-select')) {
                    $(this).selectric({
                        maxHeight: 200,
                        disableOnMobile: false,
                        nativeOnMobile: false,
                        arrowButtonMarkup: '<b class="selectric__button icon-arrow-down"></b>',
                        onInit: function () {
                            var current_option = $(this),
                                current_option_value = current_option.val(),
                                selectric_container = $(this).parents('.selectric-wrapper').find('.selectric');

                            // проверка для вывода поля с секретным ответом
                            if (typeof current_option.attr('data-secret-question') !== typeof undefined && current_option.attr('data-secret-question') !== false) {
                                if (current_option_value) {
                                    secret_answer.show();
                                } else {
                                    secret_answer.hide();
                                }
                            }

                            //  эмуляция placeholder'a для селектрика
                            if (current_option_value) {
                                selectric_container.removeClass('selectric--placeholder');
                            } else {
                                selectric_container.addClass('selectric--placeholder');
                            }

                            // проверка на количество эллементов, если 1 - то добавляем класс,
                            // который скрывает всю навигацию
                            if (current_option.find('option').length === 1) {
                                current_option.parents('.selectric-wrapper').addClass('selectric--void');
                            }
                        },
                        onChange: function (element) {
                            var current_option = $(this),
                                current_option_value = current_option.val(),
                                selectric_container = $(this).parents('.selectric-wrapper').find('.selectric');

                            // проверка для вывода поля с секретным ответом
                            if (typeof current_option.attr('data-secret-question') !== typeof undefined && current_option.attr('data-secret-question') !== false) {
                                if (current_option_value) {
                                    secret_answer.show();
                                } else {
                                    secret_answer.hide();
                                }
                            }

                            //  эмуляция placeholder'a для селектрика
                            if (current_option_value) {
                                selectric_container.removeClass('selectric--placeholder');
                            } else {
                                selectric_container.addClass('selectric--placeholder');
                            }
                        },
                    });
                }
            });
        }

        selectInit();
        /** End **/

        /** Меню провайдеров в селектменю **/
        $('[data-select-provider-menu]').selectric({
            maxHeight: 200,
            disableOnMobile: false,
            nativeOnMobile: false,
            responsive: false,
            arrowButtonMarkup: '<b class="selectric__button icon-arrow-down"></b>',
            onInit: function () {
                if ($(this).find('option').length === 1) {
                    $(this).parents('.selectric-wrapper').addClass('selectric--void');
                }

                $(this).parents('.selectric-wrapper').find('.selectric-items').scrollbar({
                    "showArrows": true,
                    "scrolly": 'advanced',
                    "ignoreOverlay": false
                });
            },
            onBeforeOpen: function () {
                // alert('bb');
            },
        }).on('change', function () {
            location.href = $(this).val();
        });
        /** End **/


        /** Block Seo-text **/
        $('.seo-text__show-more').on('click', function () {
            $(this).toggleClass('rotate');
            $('.seo-text__wrapper').toggleClass('open');
        });
        /** End Block Seo-text **/


        /** Инициализация select menu валют **/
        $('[data-select-currency]').selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
            arrowButtonMarkup: '<b class="selectric__button icon-arrow-down"></b>',
            onInit: function () {
                if ($(this).find('option').length === 1) {
                    $(this).parents('.selectric-wrapper').addClass('selectric--void');
                }
            }
        }).on('change', function () {
            location.href = $(this).val();
        });
        /** End Инициализация select menu валют **/

        /** Fix для пагинации таблиц в кабинете игрока (решение под вопросом, костыль из-за бэкендеров) **/
        DOC.on('click', '.pager__item a', function (event) {
            $('html, body').animate({
                scrollTop: $('#table-top').offset().top
            }, 500);
        });
        /** End Fix для пагинации таблиц в кабинете игрока **/

        /** Fix Hover on mobile **/
        fixHover('.games__item', '.games__item__overlay', 'games__item__overlay--active');

        function fixHover(sSelestor, sHover, sActiveClass) {
            $(sSelestor).hover(
                function () {
                    $(this)
                        .find(sHover)
                        .addClass(sActiveClass);
                },
                function () {
                    $(this)
                        .find(sHover)
                        .removeClass(sActiveClass);
                }
            );
        }

        /** End Fix Hover on mobile **/


        /**
         * Инициализация поля выбора даты
         * Используется в формах, которые подгружаются на ajax
         * Для этого вынесен в функцию для использования внутри ajaxSuccess
         **/
        function dateInit() {
            let input_date = $('[data-date]');
            if (input_date.length > 0 && input_date.is(':visible')) {
                if (!$('.datepickers-container').length) {
                    let date = (new Date()).getFullYear();
                    let maxdate = new Date();
                    maxdate.setYear(date - 18);

                    input_date.datepicker({
                        maxDate: maxdate,
                        autoClose: true,
                        dateFormat: 'yyyy-mm-dd',
                        language: 'en'
                    });
                }
            }
        }

        dateInit();
        /** End **/

        /** Avatar load в профиле Игрока **/
        var readURL = function (input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('.profile-pic').attr('src', e.target.result);
                };
                reader.readAsDataURL(input.files[0]);
            }
        };
        $('#avatar-form').submit(function () {
            readURL($('#avatar-input'));
        });

        $("[data-avatar-submit]").on('click', function () {
            $("[data-avatar-upload]").click();
        });

        /** End Avatar load в профиле Игрока **/



        /**
         *  Табы в виде трансформера из табов в селекты
         *
         *    data-tabs - аттрибут, по которому происходит инициализация работы табов
         *
         *    data-tabs-save - аттрибут, который, фактически активирует сохранение активного таба в LocalStorage
         *        Для него нужно указать имя, которое будет использоваться для идентификации текущей страницы
         *
         *    data-tabs-sync - аттрибут, который активирует синхронизацию двух табов
         *        Его нужно задать для того селекта, С КОТОРЫМ нужно синхронизировать активный
         *        Если задать для обоих селектов - синхронизация будет работать в обе стороны
         *
         *    data-tabs-transform - аттрибут, значение в котороым указывает ширину экрана, меньше которой табы будут трансформироваться в селект
         *
         *    data-tabs-selector - аттрибут, добавляем его в случае, если нужно сделать выделение таба, которое с анимацией
         *        передвигается после выделения таба
         *
         * */
        function newTabs() {
            let tabs_active = 'active',
                tabs_content = '.tabs__content';

            $('[data-tabs]').each(function () {
                $(this).selectric({
                    maxHeight: 200,
                    disableOnMobile: false,
                    nativeOnMobile: false,
                    responsive: false,
                    arrowButtonMarkup: '<b class="selectric__button icon-arrow-down"></b>',
                })
                    .prop('selectedIndex', 0).selectric('refresh')
                    .on('change', function () {
                        let tabs_parent = $(this).closest('.tabs__parent'),
                            tabs_save = $(this).closest('[data-tabs-save]'),
                            tabs_save_value = tabs_save.data('tabs-save'),
                            tabs_selected = $(this).parents('.selectric-wrapper').find('li.selected'),
                            tab_counter = tabs_selected.index();

                        tabs_parent.find(tabs_content + ':first').parent().children(tabs_content).removeClass(tabs_active).eq(tab_counter).addClass(tabs_active);

                        // если указан дата аттрибут для сохранения - сохраняем его в localStorage
                        if (tabs_save.length && tabs_save_value.length) {
                            localStorage.setItem(tabs_save_value, tab_counter);
                        }

                        // синхронизация двух селектов
                        // в случае сложной адаптивной структуры, если по дизайну селект (табы) переносятся в другой блок
                        $('[data-tabs-sync]').each(function () {
                            $(this).parents('.selectric-wrapper').find('li').removeClass('selected').eq(tab_counter).addClass('selected').trigger('click');
                        })


                        if ($(this).closest('[data-tabs-selector]').length) {
                            // добавляем координаты и ширину для выделения
                            $(this).closest('[data-tabs-selector]').parents('.selectric-wrapper').find('.tabs__select').css({
                                "left": tabs_selected.position().left + "px",
                                "width": tabs_selected.innerWidth() + "px"
                            });
                        }

                    });

                // создаём элемент, который будет использоваться как выделение
                if ($(this).closest('[data-tabs-selector]').length) {
                    let tabs_current = $(this).parents('.selectric-wrapper').find('li.selected');
                    $(this).parents('.selectric-wrapper').find('.selectric-scroll').prepend('<span class="tabs__select" style="width: ' + tabs_current.innerWidth() + 'px; left:' + tabs_current.position().left + 'px"></span>');
                }

                // находим общего родителя для табов и контена табов и проставляем классы
                let tabs_parent = $($(this).parents().get().find(itm => $(itm).find(tabs_content).length)),
                    tabs_save = $(this).closest('[data-tabs-save]'),
                    tabs_save_value = tabs_save.data('tabs-save');

                tabs_parent.addClass('tabs__parent');

                // если установлено сохранение активного таба - при загрузке страницы эмулируем клик на него
                if (tabs_save.length && tabs_save_value.length) {
                    setTimeout(function () {
                        // если не будет установлено ни одного active у контента, то добавляем его сами
                        tabs_parent.find(tabs_content).eq(localStorage.getItem(tabs_save_value)).addClass(tabs_active);

                        tabs_save.parents('.selectric-wrapper').find('li:eq(' + localStorage.getItem(tabs_save_value) + ')').trigger('click');
                    }, 1);
                }
            });
        }

        newTabs();

        /**
         * Значение, при котором изменяется тип табов (табы или селект) задается в дата-аттрибут data-tabs-transform
         */
        function tabsTypeCheck() {
            $('[data-tabs-transform]').each(function () {
                let windowWidth = $(this).data('tabs-transform');
                if (WIN.width() <= windowWidth) {
                    $(this).parents('.select').removeClass('select--tabs').addClass('select--transformed');
                } else {
                    $(this).parents('.select').addClass('select--tabs').removeClass('select--transformed');

                }
            });
        }

        tabsTypeCheck();


        /**
         * Пересчёт позиции выделения табов (если есть аттрибут data-tabs-selector)
         * */
        function tabsSelect() {
            $('[data-tabs]').each(function () {
                var attr = $(this).data('tabs-selector');

                if (typeof attr !== typeof undefined && attr !== false) {
                    let tabs_selected = $(this).parents('.selectric-wrapper').find('li.selected');

                    $(this).closest('[data-tabs-selector]').parents('.selectric-wrapper').find('.tabs__select').css({
                        "left": tabs_selected.position().left + "px",
                        "width": tabs_selected.innerWidth() + "px"
                    });
                }


                if ($(this).data('tabs-selector')) {

                }
            });
        }

        tabsSelect();
        /** End New tabs **/


        /** !!! определить необходимость для данного проекта !!! **/
        DOC.on('click', '[data-sidebar-toggler]', function () {
            var sidebar = $('[data-sidebar]');
            $(this).toggleClass('active')
            sidebar.slideToggle();
            sidebar.toggleClass('open');
        });
        /** !!! определить необходимость для данного проекта !!! **/


        /** Определяем ширину скроллбара в текущем браузере !!! определить необходимость для данного проекта !!!????? **/
        var div = document.createElement('div');

        div.style.overflowY = 'scroll';
        div.style.width = '50px';
        div.style.height = '50px';
        div.style.visibility = 'hidden';

        document.body.appendChild(div);
        var scrollWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
        /** End Определяем ширину скроллбара в текущем браузере **/


        /** Событие клика на элементе faq. Показывает\скрывает ответ на вопрос */
        DOC.on('click', '[data-faq-question]', function () {
            var item = $(this).parents('.faq__item');
            item.find('.faq__answer').slideToggle();
            item.toggleClass('faq--open');
        });

        /** End **/


        /**
         * Иниализация отложенной подгрузки изображений + замена битого изображения логотипом проекта
         * https://skeleton.gitbook.io/docs/js/jquery-lazy
         **/
        function lazyLoad() {
            $('[data-lazy] img[data-src]').Lazy({
                scrollDirection: 'vertical',
                effect: "fadeIn",
                effectTime: 1000,
                onError: function (el) {
                    el.attr("src", "../img/logos/no-photo.png").parent().addClass('no-photo');
                }
            });
        }

        lazyLoad();


        /** Событие смены видимости пароля в инпуте */
        var passwordToggler = ('[data-password-toggler]');
        DOC.on('click', passwordToggler, function () {
            var btn = $(this),
                input = btn.siblings('input');
            btn.toggleClass('icon-view');
            btn.toggleClass('icon-hide');
            if (input.attr('type') == 'text') {
                input.attr('type', 'password');
            } else {
                input.attr('type', 'text');
            }
        });
        /** End **/


        /**
         * Инициализация плагина обратного отсчета
         * https://skeleton.gitbook.io/docs/js/jquery-countdown
         */
        $('[data-time]').each(function () {
            $(this).countdown($(this).attr('data-time'), function (event) {
                $(this).html(event.strftime('' +
                    '<div class="counter__block">' +
                    '<span class="counter__value">%D</span>' +
                    '<span class="counter__desc">' +
                    $(this).attr('data-days') +
                    '</span>' +
                    '</div>' +
                    '<dl>:</dl>' +
                    '<div class="counter__block">' +
                    '<span class="counter__value">%H</span>' +
                    '<span class="counter__desc">' +
                    $(this).attr('data-hours') +
                    '</span>' +
                    '</div>' +
                    '<dl>:</dl>' +
                    '<div class="counter__block">' +
                    '<span class="counter__value">%M</span>' +
                    '<span class="counter__desc">' +
                    $(this).attr('data-min') +
                    '</span>' +
                    '</div>' +
                    '<dl>:</dl>' +
                    '<div class="counter__block">' +
                    '<span class="counter__value">%S</span>' +
                    '<span class="counter__desc">' +
                    $(this).attr('data-sec') +
                    '</span>' +
                    '</div>'
                ));
            });
        });


        /** Маска для телефонного инпута **/

        // $(function($){
        //     $("input[type='tel']").mask("+(99) 99999-99999", {autoclear: false});
        // });

        /** End **/


            // TODO если на странице больше 1 телефонного инпута, сделать инициализацию в цикле
        var input = document.querySelector("input[type=tel]");
        if ($("input[type=tel]").length) {
            window.intlTelInput(input, {
                initialCountry: "auto",
                autoHideDialCode: false,
                nationalMode: false,
                // separateDialCode: true,
                // hiddenInput: "full_phone",
                numberType: "MOBILE",
                geoIpLookup: function (callback) {
                    $.get('https://ipinfo.io', function () {
                    }, "jsonp").always(function (resp) {
                        var countryCode = (resp && resp.country) ? resp.country : "";
                        callback(countryCode);
                    });
                },
                utilsScript: "/front/js/utils.js"
            });
        }
        /** End **/

        /** Input animation **/

        // //Load animation if fields containing data on page load
        // $(".input").each(function() {
        //     if ($(this).val() != "") {
        //         $(this).parent().addClass("animation");
        //     }
        // });
        //
        // //Add animation when input is focused
        // $(".input").focus(function(){
        //     $(this).parent().addClass("animation animation-color");
        // });
        //
        // //Remove animation(s) when input is no longer focused
        // $(".input").focusout(function(){
        //     if($(this).val() === "")
        //         $(this).parent().removeClass("animation");
        //     $(this).parent().removeClass("animation-color");
        // })

        /** End **/


        /** Tabs с дополнительной инофрмацией на странице отдельной игры **/
        $('[data-game-tabs]').on('click', 'li:not(.active)', function () {
            $(this).addClass('active').siblings().removeClass('active').closest('div.game__box--right')
                .find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
            if ($('[data-tabs-tournament]').hasClass('active')) {
                $('[data-topinfo]').addClass('open');
            } else {
                $('[data-topinfo]').removeClass('open');
            }
        });
        /** End **/

        /**
         * Условие проверки входа через IE
         * И вывод соответствующего сообщения об устаревшем браузере
         **/
        if (!HTML.hasClass('ie')) {
            $('.ieOff').remove();
        }
        /** End **/

        /**
         * Детектирование включенного AdBlock'a у пользователя
         * Если он активирован - выводим сообщение
         * При закрытии этого сообщение результат записываем в sessionStorage
         * и в следующий раз уже не отображаем сообщение
         **/
            //sessionStorage.clear();  // очищаем sessionStorage и показываем уведомление при каждой перезагрузке

        let alert_container = $('.alert');

        function adBlockDetected() {
            let alert_status = sessionStorage.getItem('alert');
            if (alert_status !== '0') {
                alert_container.show();
            }
        }

        if (typeof fuckAdBlock === 'undefined') {
            adBlockDetected();
        } else {
            fuckAdBlock.onDetected(adBlockDetected);
        }
        DOC.on('click', '[data-alert-close]', function () {
            alert_container.hide();
            sessionStorage.setItem('alert', '0');
        });

        /** Language select **/
        DOC.on("click", "[data-lang]", function() {
            $(this).parents('.lang').toggleClass('opened')
            $(this).siblings('.lang__dropdown').slideToggle();
        });

        $(".lang-select .lang-select__item").click(function () {
            $(this).siblings(".lang-select__item").removeClass('active');
            $(this).toggleClass('active')
        });

        /** Закрытие списка языков при клике вне его **/
        DOC.on('click', function(e){
            if (!$(e.target).closest("[data-lang]").length) {
                $("[data-lang]").removeClass('opened');
                $('.lang__dropdown').slideUp();
                $(".lang").removeClass('opened');

            }
            e.stopPropagation();
        });
        /** End **/


        /**
         * Инициализация модального окна, inline type
         */

        $('[data-modal-inline]').magnificPopup({
            type: 'inline',
            midClick: true
        });




        $('[data-provider-menu-toggler]').click(function () {
            var elem = $(this).text();
            var textFolded = $(this).data("text-folded");
            var textUnfolded = $(this).data("text-unfolded");

            if (elem == textFolded) {
                //Stuff to do when btn is in the read more state
                $(this).text(textUnfolded);
                $('[data-provider-menu-content]').addClass('visible');
            } else {
                //Stuff to do when btn is in the read less state
                $(this).text(textFolded);
                $('[data-provider-menu-content]').removeClass('visible');
            }
        });
        /** End Раскрытие меню провайдеров в футере **/


        /**
         * Раскрытие фрейма с игрой на доступную ширину в контентной части сайта
         * **/
        DOC.on("click", "[data-game-widescreen]", function () {
            $(this).toggleClass('active').parents('.game').toggleClass('hide-game-panel');
        });

        /**
         * Раскрытие дополнительно текста к 2х факторной аутентификации (2factor auth)
         * **/
        DOC.on("click", "[data-2fac-toggler]", function () {
          $(this).toggleClass('toggled');
        });

        /**
         * Раскрытие фрейма с игрой на весь экран
         * **/
        DOC.on('click', '[data-game-fullscreen]', function () {
            $('.game__iframe iframe, .game__iframe img').fullscreen();
        });


        /**
         * Закрытие блока при клике вне его пределов
         * */
        DOC.on('click', function (e) {
            // меню залогиненного пользователя
            if (!$(e.target).closest("[data-mobile-wrapper-user] *, [data-mobile-menu-user]").length) {
                $('[data-mobile-wrapper-user]').removeClass('opened');
            }

            // меню пользователя
            if (!$(e.target).closest("[data-mobile-wrapper] .mobile-wrapper__content, .header-switch__container, [data-mobile-menu]").length) {
                $('[data-mobile-wrapper]').removeClass('opened');
                $('[data-mobile-menu]').removeClass('active');
                BODY.removeClass('blur fixed');
            }

            // if (!$(e.target).closest('.lang__dropdown').length) {
            //     $(this).parents('.lang').toggleClass('opened')
            // }

            // профиль игрока с соц сетями
            if (!$(e.target).closest("[data-social-wrapper] *, [data-profile-social]").length) {
                $('[data-social-wrapper]').removeClass('opened');
            }

            // резиновое меню
            if (!$(e.target).closest(".menu-dd__item, .menu-dd__dropdown").length) {
                $('[data-menu] .menu-dd__item').removeClass('open');
            }

            e.stopPropagation();
        });

        /**
         * Создание резинового меню
         * https://skeleton.gitbook.io/docs/js/response-menu
         * **/
        function responseMenu() {
            $('[data-menu]').each(function () {
                let menu_container = $(this),
                    menu_more,
                    menu_more_link;

                // вставляем элемент со скрытым списком
                if (!menu_container.find('.menu-dd__item').length) {
                    menu_more = menu_container.find('li:first-of-type').clone().addClass("menu-dd__item");
                    menu_container.prepend(menu_more);
                    menu_more_link = menu_more.find('> * ');

                    let attr = $(this).data('menu-icon'),
                        menu_icon = '';

                    if (typeof attr !== typeof undefined && attr !== false) {
                        menu_icon = '<i class="' + attr + '"></i>'
                    }

                    menu_more_link.replaceWith(function () {
                        return $('<span class="' + menu_more_link.attr('class') + ' menu-dd__button">' + menu_icon + '<span>' + menu_container.data('menu') + '</span></span>');
                    });
                    menu_more.append('<ul class="menu-dd__dropdown"></ul>');
                }

                menu_container.find('.menu-dd__dropdown li').appendTo(menu_container);

                let
                    items = menu_container.find(' > li:not(.menu-dd__item)'),
                    menu_button = menu_container.find('.menu-dd__item'),
                    menu_maxWidth = parseInt(menu_container.width()) - parseInt(menu_button.outerWidth()),
                    menu_width = 0, // общая длина меню (сума длинны видимых пунктов)
                    menu_hideFrom = 0, // начиная с какого по порядку пункту меню переносим пункты в подменю
                    menu_hideFrom_custom = menu_container.data('menu-max') - 1;

                items.each(function (index) {
                    // округляем ширину текущего пункта меню до целого числа в большую сторону
                    let item_width = Math.ceil($(this).outerWidth());

                    if (menu_width + item_width > menu_maxWidth) {
                        return false;
                    } else {
                        // считаем, начиная с какого пункта нужно переносить пункты в подменю
                        menu_hideFrom = index;

                        // считаем общую ширину всех видимых пунктов меню
                        menu_width += item_width;
                    }
                });

                if (menu_hideFrom_custom && menu_hideFrom_custom < menu_hideFrom) {
                    menu_hideFrom = menu_hideFrom_custom;
                }

                // переносим пункты меню в дропдаун
                if (menu_hideFrom < parseInt(items.length)) {
                    items.eq(menu_hideFrom).nextAll('li').appendTo(menu_container.find('.menu-dd__dropdown'));
                    menu_button.addClass('menu-dd__item--active').removeClass('active');
                } else {
                    menu_button.removeClass('menu-dd__item--active');
                }
            });
        }

        responseMenu();

        DOC.on('click', '.menu-dd__button', function () {
            $(this).parent().toggleClass('open');
        });

        /** Switcher Toggle Telegram **/
        DOC.on("click", "[data-telegram-checkbox]", function () {
            $(this).toggleClass('active');
        });
        /** END Switcher Toggle Telegram **/

        /** telegram message turning off **/
        DOC.on('click', '[data-telegram-close]', function () {
            $('.telegram-block__wrapper').removeClass('shown');
            if ($('.telegram__checkbox--inner').hasClass('active')) {
                localStorage.setItem('telegram', 'check');
                $('.telegram-block__wrapper').removeClass('shown');
            }
        });
        if (localStorage.telegram !== 'check') {
            $('.telegram-block__wrapper').addClass('shown');
        }
        /** END telegram message turning off **/

        $('[data-providers-toggler]').on('click', function () {
            $(this).toggleClass('rotate');
            $('[data-providers-wrapper]').toggleClass('open');
        });

        /**
         * Переключение пустой и заполненной страницы
         */
        DOC.on("change", "[data-page-switch]", function () {
            if ($(this).find('input').is(':checked')) {
                $('.pageSwitch--void').toggle();
                $('.pageSwitch--full').hide();
            } else {
                $('.pageSwitch--void').toggle();
                $('.pageSwitch--full').show();
            }
        });

        /**
         * Действия при ресайзе окна
         * */
        WIN.on('resize', function () {
            // при ресайзе эмулируем клик на body, из-за этого срабатывает скрипт закрытия блока меню
            BODY.trigger('click');

            // проверка типа табов
            tabsTypeCheck();

            // ресайз меню
            responseMenu();

            tabsSelect();
        });

        /* Событие копирования в буфер обмена при клике на кнопку / 2fac */
        DOC.on('click', '[data-copy-code-trigger]', function() {
          var element = $('[data-copy-code]');
          var $temp = $("<input>");
          $("body").append($temp);
          $temp.val($(element).text()).select();
          document.execCommand("copy");
          $temp.remove();
        });

        /* ----- 2fac confirmation code: 6 inputs --------------------------------- */
        $('body').on('keyup', '[data-inputs-group] .form__input-wrapper input', function() {
          /* focus next input after fill prev */
          if (this.value.length == this.maxLength) {
            $(this).closest('.form__input-wrapper').next('.form__input-wrapper').children('input').focus();
          }
          /* delete value */
          var key = event.keyCode || event.charCode;
          if( key == 8 || key == 46 ){
            $(this).closest('.form__input-wrapper').prev('.form__input-wrapper').children('input').focus().select();
          }
        });
        /* ------------------------------------------------------------------------ */


        // // FOR LOCAL registration bonus add class active

        // function bonusCheck() {
        //     $('.special-radio__list .special-radio input').each(function() {
        //         $(this).parent().removeClass('special-radio__active');
        //
        //         if ($(this).is(':checked')) {
        //             $(this).parent().addClass('special-radio__active');
        //         }
        //     });
        // }
        //
        // DOC.on('click', '.special-radio__list .special-radio', function(){
        //     bonusCheck();
        // });
        //
        // bonusCheck();


        // // END registration bonus add class active

        // $('[data-de]').on('click', function() {
        //     $("html").attr("lang", 'de');
        // })
        // $('[data-en]').on('click', function() {
        //     $("html").attr("lang", 'en');
        // })
        // $('[data-ru]').on('click', function() {
        //     $("html").attr("lang", 'ru');
        // })
        // $('[data-es]').on('click', function() {
        //     $("html").attr("lang", 'es');
        // })

        /** Событие срабатывает в случае успешного выполнения ajax запроса **/
        $(document).on('ajaxSuccess', function () {
          selectInit();
          lazyLoad();
          dateInit();
          dataCutText();
          /** Слайдер выбора бонуса на депозит в модалке **/
          chooseBonus();
          /** Ввод верификационный код **/
          enterCode();

          //-- Инициализация модалок --
      		$('[data-modal]').magnificPopup({
      			type: 'ajax',
      			removalDelay: 300,
      			mainClass: 'mfp-zoom-in',
      			callbacks: {
      				parseAjax: function(mfpResponse) {
      					mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
      				},
      				ajaxContentAdded: function() {
      					this.content;
      				},
      				open: function() {
      					$('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
      				},
      				close: function() {
      					$('.header').css('width', '100%')
      				},
      				beforeOpen: function() {
      					$('body').addClass('blur');
      				},
      				beforeClose: function() {
      					$('body').removeClass('blur');
      				}
      			}
      		});
        });
        /** Раскрытие меню провайдеров в футере **/

    });
